import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import UploadIcon from '@mui/icons-material/Upload';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import { useForm, Controller } from 'react-hook-form';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FormControl, FormHelperText } from '@mui/material';
import CustomizedDialogs from '../components/ModalAlert';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import InputMask from 'react-input-mask';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import { useQuery } from '../hooks/useQuery';
import Moment from 'moment';
import 'moment/locale/pt-br';
import { useAuth } from '../hooks/useAuth';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import { useSnackbar } from '../hooks/useSnackbar';
import {
  cryptedParam,
  decryptedParam,
  encryptData,
  handleHttpError,
  PENDENCIA_FORNECEDOR,
  PENDENCIA_GESTOR,
} from '../utils';
import NotaFiscal from '../models/NotaFiscal';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { isCnpj, serializeQueryString } from '../utils';
import { useModalLoading } from '../hooks/useModalLoading';

let debounce = null;

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export const CarregarNotaFiscalPage = ({
  activeStep,
  setActiveStep,
  steps,
  codigoContrato,
  user,
  nfs,
  notaFiscal,
  setNotaFiscal,
  setNfs,
  cnpj,
  isContract,
  contratoId,
  contratoDts,
  gestor,
}) => {
  const [file, setFile] = React.useState(null);
  const [visible, setVisible] = React.useState(true);
  const [radioValue, setRadioValue] = React.useState('xml');
  const [radioValueSub, setRadioValueSub] = React.useState('yes');
  const [fornecedor, setFornecedor] = React.useState(null);
  const [cnpjMatrizFilial, setCnpjMatrizFilial] = React.useState(null);
  const [loadingAutocomplete, setLoadingAutocomplete] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [optionsFilial, setOptionsFilial] = React.useState([]);
  const { search } = useLocation();
  const params = useParams();
  const [mask, setMask] = React.useState('(99) 99999-9999');
  let [searchParams, setSearchParams] = useSearchParams();
  const paramsSearch = new URLSearchParams(search);
  const theme = useTheme();
  const navigate = useNavigate();
  const snackbar = useSnackbar();

  const {
    handleSubmit,
    control,
    setValue,
    reset,
    getValues,
    watch,
    formState: { errors },
  } = useForm({});

  const [show, setShow] = React.useState(false);
  const [dataCnpj, setDataCnpj] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [loadingFornecedor, setLoadingFornecedor] = React.useState(false);
  const [isRascunho, setIsRascunho] = React.useState(true);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('');
  const [municipios, setMunicipios] = React.useState([]);
  const [municipio, setMunicipio] = React.useState();
  const [estados, setEstados] = React.useState([]);
  const [codMunicipio, setCodMunicipio] = React.useState(0);
  const { user: userSession, isUsuarioSebrae } = useAuth();
  const [usersComunicacao, setUsersComunicacao] = React.useState([]);
  const inputFile = React.useRef(null);
  const inputFone = React.useRef(null);
  const autoCompleteMunicipio = React.useRef(null);
  const dateEmissaoInput = React.useRef(null);
  const validadeBlocoInput = React.useRef(null);
  const [codEmitente, setCodEmitante] = React.useState(null);
  const [validadeStatus, setValidateStatus] = React.useState(false);
  const [dataEmissaoValida, setDataEmissaoValida] = React.useState(true);

  const {
    listarMunicipios,
    obterFornecedorPorCnpj,
    listarEstados,
    parsearXml,
    parsearPdf,
    criarNotaFiscal,
    atualizarNota,
    listarFornecedores,
    validarPermissaoEnvioNota,
  } = useQuery();

  const modalLoading = useModalLoading();

  const onErrors = (errors) => {
    // window.scrollTo(0, 0);
    console.log(errors);
  };

  const fornecedores = async (term, subcontratada = false) => {
    setLoadingAutocomplete(true);
    const newTerm = isCnpj(term) ? term.replace(/[^a-zA-Z0-9]/g, '') : term;

    const result = await listarFornecedores(newTerm);
    if (result && result.data && result.data.data) {
      const arr = result.data.data.map((item) => ({
        ...item,
        cnpj_sem_pontos: item.cnpj_fornec.replace(/[^a-zA-Z0-9]/g, ''),
      }));
      if (notaFiscal && notaFiscal.cnpj_subcontratada && subcontratada) {
        const fornecedorEncontrado = arr.filter(
          (forne) =>
            notaFiscal.cnpj_subcontratada.replace(/[^a-zA-Z0-9]/g, '') ===
            forne.cnpj_sem_pontos,
        );

        if (fornecedorEncontrado.length > 0) {
          setFornecedor(fornecedorEncontrado[0]);
          // setCodEmitante(fornecedorEncontrado[0].cod_fornec);
        }
      } else {
        const fornecedorEncontrado = arr.filter(
          (forne) =>
            notaFiscal.cnpj_prestador_servico.replace(/[^a-zA-Z0-9]/g, '') ===
            forne.cnpj_sem_pontos,
        );

        if (fornecedorEncontrado.length > 0) {
          setCodEmitante(fornecedorEncontrado[0].cod_fornec);
        }
      }
      if (subcontratada) {
        setOptions(arr);
      } else {
        setOptionsFilial(arr);
      }
    }
    setLoadingAutocomplete(false);
  };

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) =>
      option.cnpj_sem_pontos + option.nome_fornec + option.cnpj_fornec,
  });

  const onChangeAutoComplete = (event) => {
    if (event.target.value.length > 0) {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        fornecedores(event.target.value, true);
      }, 1000);
    } else {
      setOptions([]);
    }
  };

  const validarDataEmissaoNota = async (data) => {
    if (/^(\d{4})-(\d{2})-(\d{2})$/.test(data) === false) return;

    if (
      [
        PENDENCIA_GESTOR,
        PENDENCIA_FORNECEDOR,
        'PENDENCIA DO FORNECEDOR',
        'PENDENCIA GESTOR',
      ].includes(notaFiscal.situacao_nf)
    )
      return;

    try {
      const result = await validarPermissaoEnvioNota({
        data,
      });

      if (!result.data.data.permitido_envio_nota) {
        setMessage(
          'Período para o lançamento de notas fiscais encerrado. Realize o cancelamento da Nota fiscal e emita um nova nota com a data de emissão atualizada.',
        );
        setType('error');
        setShow(true);
      }

      setDataEmissaoValida(result.data.data.permitido_envio_nota);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    if (dateEmissaoInput) {
      dateEmissaoInput.current.children[0].classList.remove('Mui-error');
      dateEmissaoInput.current.children[1].classList.remove('Mui-error');
      dateEmissaoInput.current.value = null;
    }

    validarDataEmissaoNota(notaFiscal.data_emissao_nf);
  }, [dateEmissaoInput]);

  React.useEffect(() => {
    setUsersComunicacao(JSON.parse(process.env.REACT_APP_USERS_SUBCONTRATADA));
    getEstados();
    fetchCnpjData();
    setRadioValueSub(notaFiscal.subcontratada);
    if (notaFiscal.tipo_envio_nf === 'M') {
      setVisible(false);
      if (
        notaFiscal.situacao_nf == 'RASCUNHO' ||
        notaFiscal.situacao_nf == undefined
      ) {
        setValidateStatus(false);
      } else {
        setValidateStatus(true);
      }

      setRadioValue('manual');
    } else if (notaFiscal.tipo_envio_nf === 'P') {
      setRadioValue('pdf');
      setVisible(false);
      if (
        notaFiscal.situacao_nf == 'RASCUNHO' ||
        notaFiscal.situacao_nf == undefined
      ) {
        setValidateStatus(false);
      } else {
        setValidateStatus(true);
      }
    } else {
      setVisible(true);
      setValidateStatus(true);
      setRadioValue('xml');
    }
  }, []);

  React.useEffect(() => {
    if (notaFiscal && notaFiscal.cnpj_subcontratada) {
      fornecedores(notaFiscal.cnpj_subcontratada, true);
    }
    fornecedores(cnpj.replace(/[^a-zA-Z0-9]/g, '').substr(0, 8));
  }, [notaFiscal]);

  React.useEffect(() => {
    if (
      notaFiscal &&
      notaFiscal.codigo_municipio_orgao_gerador &&
      notaFiscal.codigo_municipio_orgao_gerador !== 0
    ) {
      setCodMunicipio(notaFiscal.codigo_municipio_orgao_gerador);
    }
  }, []);

  React.useEffect(() => {
    if (optionsFilial && optionsFilial.length > 0) {
      if (notaFiscal && notaFiscal.cnpj_prestador_servico) {
        if (optionsFilial.length == 1) {
          setValue('cnpj_prestador_servico', notaFiscal.cnpj_prestador_servico);
        }
      } else {
        if (optionsFilial.length == 1) {
          setValue('cnpj_prestador_servico', cnpj.replace(/[^a-zA-Z0-9]/g, ''));
        }
      }
    }
  }, [optionsFilial]);

  const fetchCnpjData = async () => {
    setLoadingFornecedor(true);
    if (!isUsuarioSebrae) {
      const { data } = await obterFornecedorPorCnpj(
        userSession.cnpj.replace(/[^a-zA-Z0-9]/g, ''),
      );
      setDataCnpj(data.data);
    } else {
      const { data } = await obterFornecedorPorCnpj(
        cnpj.replace(/[^a-zA-Z0-9]/g, ''),
      );
      setDataCnpj(data.data);
    }
    setLoadingFornecedor(false);
  };

  const getMunicipios = async (estado_id) => {
    let result = await listarMunicipios(estado_id);
    setMunicipios(result && result.data && result.data.data);
    if (notaFiscal && notaFiscal.codigo_municipio_orgao_gerador) {
      const municipioEncontrado = result.data.data.filter(
        (mun) =>
          notaFiscal.codigo_municipio_orgao_gerador === mun.codigo_municipio,
      );
      if (municipioEncontrado.length > 0) {
        setMunicipio(municipioEncontrado[0]);
        setValue('codigo_municipio_orgao_gerador', municipioEncontrado[0]);
        setCodMunicipio(municipioEncontrado[0].codigo_municipio);
      }
    }
  };

  const getEstados = async () => {
    let result = await listarEstados();
    setEstados(result.data.data);

    const estado = result.data.data.find(
      (e) => e.uf === notaFiscal.uf_orgao_gerador,
    );
    if (estado) {
      getMunicipios(estado.id);
    }
  };

  const changeTipoSub = (event) => {
    setFornecedor(null);
    setRadioValueSub(event);
  };

  const changeTipo = (event) => {
    const confirm = window.confirm(
      'Você irá perder os dados e reiniciará todo o processo. Deseja continuar?',
    );

    setRadioValue(event);

    if (!confirm) return;
    notaFiscal = new NotaFiscal();
    notaFiscal.natureza_operacao = 0;
    notaFiscal.iss_retido = 0;
    notaFiscal.cnpj_subcontratada = null;

    if (event === 'xml') {
      setVisible(true);
      notaFiscal.tipo_envio_nf = 'X';
      setValidateStatus(true);
    } else if (event === 'pdf') {
      notaFiscal.tipo_envio_nf = 'P';
      setValidateStatus(true);
      setVisible(true);
    } else {
      if (
        notaFiscal.situacao_nf == 'RASCUNHO' ||
        notaFiscal.situacao_nf == undefined
      ) {
        setValidateStatus(false);
      } else {
        setValidateStatus(true);
      }
      setVisible(false);
      notaFiscal.tipo_envio_nf = 'M';
    }

    setFile(null);

    if (dataCnpj && dataCnpj.ender_fornec) {
      const [rua, numero] = dataCnpj.ender_fornec.split(',');
      notaFiscal.endereco = rua;
      notaFiscal.numero_endereco = numero;
      notaFiscal.aliquota = 0;
    }

    if (optionsFilial.length == 1) {
      notaFiscal.cnpj_prestador_servico = cnpj.replace(/[^a-zA-Z0-9]/g, '');
      setFornecedor(cnpj.replace(/[^a-zA-Z0-9]/g, ''));
      setValue('cnpj_prestador_servico', cnpj.replace(/[^a-zA-Z0-9]/g, ''));
    }

    notaFiscal.razao_social = dataCnpj && dataCnpj.nome_fornec;
    notaFiscal.bairro = dataCnpj && dataCnpj.bairro_fornec;
    notaFiscal.uf_endereco = dataCnpj && dataCnpj.uf_fornec;
    notaFiscal.cep_endereco = dataCnpj && dataCnpj.cep_fornec;
    notaFiscal.inscricao_municipal = dataCnpj && dataCnpj.ins_municipal;
    notaFiscal.telefone_contato = dataCnpj && dataCnpj.telef_fornec;
    notaFiscal.email_contato = dataCnpj && dataCnpj.email_fornec;

    const v = dataCnpj.telef_fornec.replace(/\D/g, '');
    if (v.length === 10) {
      setMask('(99) 9999-9999');
    } else {
      setMask('(99) 99999-9999');
    }

    setNotaFiscal(notaFiscal);
    reset(notaFiscal);
    setValue('codigo_municipio_orgao_gerador', null);
    setValue('codigo_municipio', null);
  };

  const handleNext = async () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      Object.entries(data).forEach(([k, v]) => (notaFiscal[k] = v));

      notaFiscal.codigo_municipio_servico = Number(codMunicipio);
      notaFiscal.codigo_municipio_orgao_gerador = Number(codMunicipio);
      notaFiscal.cnpj_contexto = cnpj;
      notaFiscal.emitente = codEmitente;

      if (codMunicipio == 0 || codMunicipio == undefined) {
        setMessage('Favor preencher o município.');
        setType('error');
        setShow(true);
        setLoading(false);
        return;
      }

      if (!data.data_emissao_nf) {
        setMessage('Preencha a data de emissão');
        setType('error');
        setShow(true);
        setLoading(false);
        return;
      }

      if (file) {
        notaFiscal.arquivo = file;
      } else {
        notaFiscal.arquivo = null;
      }

      if (isContract) {
        notaFiscal.codigo_contrato = codigoContrato;
      } else {
        notaFiscal.codigo_ordem_compra = codigoContrato;
      }

      if (notaFiscal.data_emissao_nf) {
        notaFiscal.data_emissao_nf = Moment(notaFiscal.data_emissao_nf).format(
          'YYYY-MM-DD',
        );
      }

      if (notaFiscal.validade_bloco) {
        notaFiscal.validade_bloco = Moment(notaFiscal.validade_bloco).format(
          'YYYY-MM-DD',
        );
      }

      if (radioValueSub == 'yes') {
        notaFiscal.cnpj_subcontratada =
          fornecedor && fornecedor.cnpj_fornec.replace(/[^a-zA-Z0-9]/g, '');
      } else {
        notaFiscal.cnpj_subcontratada = null;
      }

      notaFiscal.subcontratada = radioValueSub;
      notaFiscal.contrato_dts = contratoDts;

      delete notaFiscal.data_competencia;
      setNotaFiscal(notaFiscal);

      const formData = new FormData();
      Object.entries(notaFiscal).forEach(([k, v]) => formData.append(k, v));

      if (notaFiscal.id) {
        await atualizarNota(notaFiscal.id, notaFiscal);
        setLoading(false);
        setMessage('Nota Fiscal atualizada com sucesso');
        setType('success');
        setShow(true);
      } else {
        const response = await criarNotaFiscal(formData);
        const { id } = response.data;
        notaFiscal.id = id;
        setNotaFiscal(notaFiscal);

        setSearchParams(searchParams);
        setLoading(false);
        setMessage('Nota Fiscal gerada com sucesso');
        setType('success');
        setShow(true);
        setFile(null);
      }

      if (!isRascunho) {
        handleNext();
      } else {
        snackbar.showSnackbar('Rascunho salvo com sucesso.');
        navigate(`/dashboard/notas/${params.contratoId}`);
      }
    } catch (error) {
      setLoading(false);
      setMessage(handleHttpError(error));
      setType('error');
      setShow(true);
    }
  };

  const onChangeFile = async (event) => {
    if ([...event.target.files].length === 0) return;

    const f = event.target.files[0];

    if (f.type !== 'text/xml' && f.type !== 'application/pdf') {
      setMessage(
        `Formato de arquivo inválido. Suportado apenas ${
          radioValue === 'pdf' ? 'PDF' : 'XLS'
        }.`,
      );
      setType('error');
      setShow(true);
      return;
    }

    setFile(f);
    setLoading(true);

    const formData = new FormData();

    formData.append('arquivo', f);
    formData.append(
      'natureza_operacao',
      notaFiscal.natureza_operacao === '1' ? 'servico' : 'produto',
    );

    try {
      if (radioValue === 'pdf') {
        modalLoading.show(
          'Inteligência artificial analisando seu PDF. Aguarde!',
        );

        let { data } = await parsearPdf(formData);

        data = data.data;

        if (
          cnpj.replace(/[^a-zA-Z0-9]/g, '') !==
          data.cnpj.replace(/[^a-zA-Z0-9]/g, '')
        ) {
          setMessage(
            'CNPJ do PDF é diferente do CNPJ selecionado. Adicione o PDF corretamente',
          );
          setType('error');
          setShow(true);
          return;
        }

        const nrNota = data.numero_nota.replace(/[^a-zA-Z0-9]/g, '');
        setValue('numero_nf', nrNota);
        notaFiscal.numero_nf = nrNota;

        setValue('data_emissao_nf', data.data_de_emissao);
        notaFiscal.data_emissao_nf = data.data_de_emissao;
        setValue('endereco', data.endereco);
        notaFiscal.endereco = data.endereco;
        setValue('discriminacao_servico', data.discriminacao_dos_servicos);
        notaFiscal.discriminacao_servico = data.discriminacao_dos_servicos;
        setValue(
          'valor_servico',
          notaFiscal.natureza_operacao === '1'
            ? data.valor_bruto
            : data.valor_liquido,
        );
        notaFiscal.valor_servico = data.valor_liquido;
        setValue('codigo_verificacao', data.codigo_verificacao);
        notaFiscal.codigo_verificacao = data.codigo_verificacao;

        if (data.codigo_do_municipio) {
          const estado = estados.find((estado) => estado.uf === data.uf);

          if (estado) {
            setValue(
              'codigo_municipio_orgao_gerador',
              Number(data.codigo_do_municipio),
            );
            notaFiscal.codigo_municipio_orgao_gerador = Number(
              data.codigo_do_municipio,
            );

            setCodMunicipio(Number(data.codigo_do_municipio));
            setCodEmitante(Number(data.codigo_do_municipio));

            getMunicipios(estado.id);
          }
        }

        validarDataEmissaoNota(notaFiscal.data_emissao_nf);
        let find = optionsFilial.find(
          (opt) => opt.cnpj_sem_pontos == notaFiscal.cnpj_prestador_servico,
        );

        if (find) {
          setCodEmitante(find.cod_fornec);
          notaFiscal.emitente = find.cod_fornec;
        }
      } else {
        const { data } = await parsearXml(formData);

        if (
          cnpj.replace(/[^a-zA-Z0-9]/g, '') !==
          data.cnpj_prestador_servico.replace(/[^a-zA-Z0-9]/g, '')
        ) {
          setMessage(
            'CNPJ do XML é diferente do CNPJ selecionado. Adicione o XML corretamente',
          );
          setType('error');
          setShow(true);
          return;
        }

        if (data && data.numero_nf.length > 15) {
          setLoading(false);
          setMessage(
            'O Arquivo XML importado ultrapassa o limite permitido de 15 caracteres, gentileza realizar o lançamento manual desconsiderando os zeros INTERMEDIÁRIOS ou INICIAS. Exemplos: 20230000000000001122 = 20231122 ou 00000000000121221 = 121212.',
          );
          setType('error');
          setShow(true);
          return;
        }

        notaFiscal.setFromParser(data);
        let find = optionsFilial.find(
          (opt) => opt.cnpj_sem_pontos == notaFiscal.cnpj_prestador_servico,
        );

        if (find) {
          setCodEmitante(find.cod_fornec);
          notaFiscal.emitente = find.cod_fornec;
        }

        if (notaFiscal.data_emissao_nf.split('T').length > 0) {
          validarDataEmissaoNota(notaFiscal.data_emissao_nf.split('T')[0]);
        }

        Object.entries(notaFiscal).forEach(([k, v]) => {
          setValue(k, v);
        });

        setNotaFiscal(notaFiscal);

        inputFile.current.value = '';
        // setValue('codigo_municipio_orgao_gerador', municipio);
        // setValue('codigo_municipio', municipio);

        const estado = estados.find((e) => e.uf === data.uf_endereco);
        if (estado) {
          getMunicipios(estado.id);
        }
        setLoading(false);
      }
    } catch (error) {
      inputFile.current.value = '';
      setLoading(false);
      setMessage(error.response.data.message);
      setType('error');
      setShow(true);
    } finally {
      modalLoading.hide();
      setLoading(false);
    }
  };

  const onChangeEstado = ({ target }) => {
    if (!target.value) return;
    const estado = estados.find((estado) => estado.uf === target.value);
    if (estado) {
      getMunicipios(estado.id);
    }
  };

  const onChangeEstadoParaImportarXml = async ({ target }) => {
    if (!target.value) return;

    setValue('codigo_municipio_orgao_gerador', null);
    setValue('codigo_municipio', null);

    const estado = estados.find((estado) => estado.id === target.value);

    if (estado) {
      notaFiscal.uf_orgao_gerador = estado.uf;
      setNotaFiscal(notaFiscal);
      setValue('uf_orgao_gerador', estado.uf);
      let result = await listarMunicipios(estado.id);
      setMunicipios(result.data.data);
    }
  };

  const onClickGetFile = (e) => {
    if (!notaFiscal.natureza_operacao) {
      e.preventDefault();
      setMessage(
        'Selecione a natureza da operação antes de selecionar o arquivo',
      );
      setType('error');
      setShow(true);
      return;
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  React.useState(() => {
    if (
      municipios &&
      municipios.length > 0 &&
      notaFiscal.codigo_municipio_servico
    ) {
      setCodMunicipio(notaFiscal.codigo_municipio_servico);
    }
  }, [municipios]);

  return (
    <Card
      component="section"
      variant="outline"
      style={{
        borderTop: `8px solid ${theme.palette.primary.main}`,
        marginTop: '1.4rem',
      }}
    >
      <CardContent padding="10px">
        <CustomizedDialogs
          content={message}
          btnTxt={'Ok'}
          type={type}
          onClick={() => setShow(false)}
          handleClose={handleClose}
          visible={show}
        />

        <form noValidate onSubmit={handleSubmit(onSubmit, onErrors)}>
          <Grid container spacing={2}>
            <Grid container item xs={12} justifyContent={'space-between'}>
              <Controller
                name="tipo_nota"
                control={control}
                defaultValue="xml"
                rules={{ required: 'Tipo nota required' }}
                render={({ name, onBlur, onChange, value }) => (
                  <RadioGroup
                    row
                    value={value}
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    onChange={(e) => {
                      changeTipo(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      checked={radioValue === 'xml'}
                      disabled={notaFiscal.id !== '' || loadingFornecedor}
                      value="xml"
                      control={<Radio />}
                      label="Nota fiscal eletrônica (Importar arquivo XML)"
                    />
                    {process.env.REACT_APP_IA == 'S' ? (
                      <FormControlLabel
                        checked={radioValue === 'pdf'}
                        disabled={notaFiscal.id !== '' || loadingFornecedor}
                        value="pdf"
                        control={<Radio />}
                        label="Importar PDF da nota por Inteligência Artificial"
                      />
                    ) : null}
                    <FormControlLabel
                      checked={radioValue === 'manual'}
                      disabled={notaFiscal.id !== '' || loadingFornecedor}
                      value="manual"
                      control={<Radio id="manual" />}
                      label="Preencher manualmente"
                    />
                  </RadioGroup>
                )}
              />
            </Grid>

            <Grid container spacing={1} marginTop={2}>
              <Grid sm={4} item>
                <Controller
                  name="natureza_operacao"
                  id="natureza_operacao"
                  rules={{
                    required: 'campo é obrigatório',
                    validate: (value) => {
                      return value !== 0;
                    },
                  }}
                  defaultValue={
                    notaFiscal && notaFiscal.natureza_operacao
                      ? notaFiscal.natureza_operacao
                      : 0
                  }
                  control={control}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <Select
                      data-cy={`input-natureza`}
                      value={value}
                      style={{ height: 40 }}
                      error={error}
                      defaultValue={
                        notaFiscal && notaFiscal.natureza_operacao
                          ? notaFiscal.natureza_operacao
                          : 0
                      }
                      onChange={(e) => {
                        onChange(e);
                        notaFiscal.natureza_operacao = e.target.value;
                      }}
                      fullWidth
                    >
                      <MenuItem disabled value={0}>
                        Selecione a natureza de operação
                      </MenuItem>
                      <MenuItem value={'1'} data-cy={`select-option-servico`}>
                        Serviço
                      </MenuItem>
                      <MenuItem value={'2'} data-cy={`select-option-produto`}>
                        Produto
                      </MenuItem>
                    </Select>
                  )}
                />
                {errors && errors.natureza_operacao ? (
                  <FormHelperText>
                    {' '}
                    <span style={{ color: '#DC143C' }}>
                      Natureza de operação obrigatório
                    </span>
                  </FormHelperText>
                ) : null}
              </Grid>
              {(visible && notaFiscal.id === '') || radioValue === 'pdf' ? (
                <>
                  <Grid item xs={12} sm={10}>
                    <TextField
                      disabled
                      style={{ width: '100%', height: 38 }}
                      id="outlined-basic"
                      value={(file && file.name) || ''}
                      placeholder={
                        radioValue === 'pdf'
                          ? 'Importar PDF da Nota Fiscal'
                          : 'Importar arquivo XML'
                      }
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      style={{ width: '100%', height: 40 }}
                      variant="contained"
                      component="label"
                      onClick={onClickGetFile}
                    >
                      <UploadIcon />
                      Importar
                      <input
                        onChange={onChangeFile}
                        hidden
                        ref={inputFile}
                        accept="text/xml,application/pdf"
                        type="file"
                      />
                    </Button>
                  </Grid>
                </>
              ) : null}
            </Grid>

            <Grid
              style={{ marginTop: 10, paddingTop: 0 }}
              container
              spacing={0}
              bgcolor={'#F9FBFF'}
            >
              <Grid style={{ margin: 5 }} container spacing={1}>
                <Grid item xs={12}>
                  <strong>Municipio da Nota Fiscal</strong>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  marginTop={2}
                  style={{ paddingTop: 0 }}
                >
                  <Controller
                    name="uf_orgao_gerador"
                    id="uf_orgao_gerador"
                    rules={{
                      required: 'UF é obrigatório',
                      validate: (value) => {
                        return value !== 0;
                      },
                    }}
                    defaultValue={notaFiscal.uf_orgao_gerador}
                    control={control}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <Select
                        data-cy={`input-estado`}
                        value={value}
                        style={{ height: 38 }}
                        error={error}
                        disabled={visible && radioValue !== 'pdf'}
                        onChange={(e) => {
                          onChange(e);
                          onChangeEstado(e);
                        }}
                        fullWidth
                      >
                        <MenuItem disabled value={0}>
                          Selecione o estado
                        </MenuItem>
                        {estados.map((estado) => {
                          return (
                            <MenuItem
                              key={estado.uf}
                              value={estado.uf}
                              data-cy={`select-option-${estado.uf}`}
                            >
                              {estado.nome}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  marginTop={2}
                  style={{ paddingTop: 0 }}
                >
                  <Controller
                    name="codigo_municipio_orgao_gerador"
                    id="municipio"
                    rules={{
                      required: 'Código município é obrigatório',
                      validate: (value) => {
                        return value !== 0;
                      },
                    }}
                    defaultValue={null}
                    control={control}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <Autocomplete
                        data-cy={`input-municipio`}
                        ref={autoCompleteMunicipio}
                        options={municipios}
                        value={value}
                        getOptionLabel={(option) => `${option.nome_municipio}`}
                        onChange={(event, newValue) => {
                          onChange(newValue);
                          setMunicipio(newValue);
                          notaFiscal.codigo_municipio_orgao_gerador = Number(
                            newValue.codigo_municipio,
                          );
                          setCodMunicipio(newValue.codigo_municipio);
                        }}
                        fullWidth
                        // disabled={visible && radioValue !== 'pdf'}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={error}
                            helperText={error && error.message}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={4}></Grid>
              </Grid>
              <Grid style={{ margin: 5, paddingTop: 0 }} container spacing={1}>
                <Grid item xs={12}>
                  <strong>
                    Informações Nfse{' '}
                    <small style={{ marginLeft: 10 }}>
                      (Preencher conforme PDF da nota. Informar somente
                      números.)
                    </small>
                  </strong>
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="numero_nf"
                    control={control}
                    defaultValue={notaFiscal.numero_nf}
                    rules={{ required: 'Número NF é obrigatório' }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <TextField
                        margin="normal"
                        placeholder="Número NF"
                        value={value}
                        id="numero_nf"
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .replace(/[^0-9]/g, '')
                            .slice(0, 16);
                        }}
                        inputProps={{
                          min: 0,
                          maxLength: 16,
                        }}
                        disabled={validadeStatus}
                        error={error}
                        helperText={error && error.message}
                        onChange={onChange}
                        fullWidth
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="codigo_verificacao"
                    control={control}
                    defaultValue={notaFiscal.codigo_verificacao}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <TextField
                        margin="normal"
                        value={value}
                        disabled={visible && radioValue !== 'pdf'}
                        error={error}
                        helperText={error && error.message}
                        onChange={onChange}
                        fullWidth
                        placeholder="Código Verificação"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="data_emissao_nf"
                    defaultValue={
                      notaFiscal.data_emissao_nf
                        ? notaFiscal.data_emissao_nf
                        : null
                    }
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <Box style={{ paddingTop: 16 }}>
                          <MobileDatePicker
                            ref={dateEmissaoInput}
                            label="Data Emissão"
                            inputFormat="DD/MM/YYYY"
                            value={value}
                            disabled={visible && radioValue !== 'pdf'}
                            maxDate={new Date()}
                            onChange={(event) => {
                              onChange(event);
                              notaFiscal.data_emissao_nf =
                                Moment(event).format('YYYY-MM-DD');

                              validarDataEmissaoNota(
                                notaFiscal.data_emissao_nf,
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                id={'data_emissao'}
                                error={false}
                                style={{ width: '100%' }}
                                {...params}
                              />
                            )}
                          />
                        </Box>
                      </LocalizationProvider>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  {!visible ? (
                    <Controller
                      name="validade_bloco"
                      control={control}
                      defaultValue={notaFiscal.validade_bloco}
                      render={({
                        field: { onChange, onBlur, ref, value },
                        fieldState: { error },
                      }) => (
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <Box style={{ paddingTop: 16 }}>
                            <MobileDatePicker
                              ref={validadeBlocoInput}
                              label="Validade do bloco"
                              inputFormat="DD/MM/YYYY"
                              onError={() => {
                                if (
                                  validadeBlocoInput &&
                                  validadeBlocoInput.current != null
                                ) {
                                  console.log('teste', validadeBlocoInput);
                                  validadeBlocoInput.current.children[0].classList.remove(
                                    'Mui-error',
                                  );
                                  validadeBlocoInput.current.children[1].classList.remove(
                                    'Mui-error',
                                  );
                                  validadeBlocoInput.current.value = null;
                                }
                              }}
                              value={value}
                              // minDate={new Date()}
                              onChange={(event) => {
                                onChange(event);
                                notaFiscal.validade_bloco =
                                  Moment(event).format('YYYY-MM-DD');
                              }}
                              renderInput={(params) => (
                                <TextField
                                  id={'validade_bloco'}
                                  error={false}
                                  style={{ width: '100%' }}
                                  {...params}
                                />
                              )}
                            />
                          </Box>
                        </LocalizationProvider>
                      )}
                    />
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}></Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}></Grid>
              </Grid>
              <Grid style={{ margin: 5, paddingTop: 0 }} container spacing={1}>
                <Grid item xs={12} alignItems={'center'} display={'flex'}>
                  <strong>Fornecedor</strong>
                  {loadingFornecedor ? (
                    <CircularProgress color={'inherit'} size={25} />
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="cnpj_prestador_servico"
                    control={control}
                    defaultValue={notaFiscal.cnpj_prestador_servico}
                    rules={{ required: 'CNPJ é obrigatório' }}
                    render={({
                      field: { onChange, onBlur, ref, value },
                      fieldState: { error },
                    }) => (
                      <Select
                        value={value}
                        error={error}
                        defaultValue={0}
                        style={{ height: 38, width: '100%', marginTop: 16 }}
                        onChange={(value) => {
                          onChange(value);
                          let find = optionsFilial.find(
                            (res) => value.target.value == res.cnpj_sem_pontos,
                          );
                          setCodEmitante(find.cod_fornec);
                        }}
                        i
                      >
                        <MenuItem disabled value={0}>
                          Selecione o cnpj
                        </MenuItem>
                        {optionsFilial.map((filial) => {
                          return (
                            <MenuItem
                              key={`cnpj-${filial.cnpj_fornec}`}
                              value={filial.cnpj_fornec.replace(
                                /[^a-zA-Z0-9]/g,
                                '',
                              )}
                            >
                              {filial.cnpj_fornec}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    )}
                  />
                  {errors && errors.cnpj_prestador_servico ? (
                    <FormHelperText>
                      {' '}
                      <span style={{ color: '#DC143C' }}>
                        Fornecedor obrigatório
                      </span>
                    </FormHelperText>
                  ) : null}
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="inscricao_municipal"
                    control={control}
                    mask="999.99999-99"
                    defaultValue={notaFiscal.inscricao_municipal}
                    render={({
                      field: { onChange, onBlur, ref, value },
                      fieldState: { error },
                    }) => (
                      <InputMask
                        mask="999.99999-99"
                        maskChar={'_'}
                        value={value}
                        onBlur={onBlur}
                        onChange={onChange}
                        disabled={true}
                      >
                        {(inputProps) => (
                          <TextField
                            margin="normal"
                            error={error}
                            ref={inputFone}
                            disabled={true}
                            helperText={error && error.message}
                            fullWidth
                            {...inputProps}
                            id="inscricao_municipal"
                            placeholder="Inscrição municipal"
                          />
                        )}
                      </InputMask>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="razao_social"
                    control={control}
                    defaultValue={notaFiscal.razao_social}
                    rules={{ required: 'Razão social é obrigatório' }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <TextField
                        margin="normal"
                        value={value}
                        disabled={true}
                        error={error}
                        helperText={error && error.message}
                        onChange={onChange}
                        fullWidth
                        placeholder="Razão Social"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="endereco"
                    control={control}
                    defaultValue={notaFiscal.endereco}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <TextField
                        margin="normal"
                        disabled={true}
                        value={value}
                        error={error}
                        helperText={error && error.message}
                        onChange={onChange}
                        fullWidth
                        placeholder="Endereço"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="numero_endereco"
                    control={control}
                    defaultValue={notaFiscal.numero_endereco}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <TextField
                        margin="normal"
                        value={value}
                        disabled={true}
                        error={error}
                        helperText={error && error.message}
                        onChange={onChange}
                        fullWidth
                        placeholder="Número"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="bairro"
                    control={control}
                    defaultValue={notaFiscal.bairro}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <TextField
                        margin="normal"
                        value={value}
                        error={error}
                        disabled={true}
                        helperText={error && error.message}
                        onChange={onChange}
                        fullWidth
                        placeholder="Bairro"
                      />
                    )}
                  />
                </Grid>
                {visible ? (
                  <Grid
                    marginTop={2}
                    item
                    xs={12}
                    sm={4}
                    style={{ paddingTop: 0 }}
                  >
                    <Controller
                      name="codigo_municipio_endereco"
                      id="codigo_municipio_endereco"
                      defaultValue={notaFiscal.codigo_municipio_endereco}
                      control={control}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <Select
                          value={value}
                          error={error}
                          style={{ height: 38 }}
                          disabled={visible}
                          onChange={onChange}
                          fullWidth
                        >
                          <MenuItem disabled value={0}>
                            Selecione o município
                          </MenuItem>
                          {municipios.map((municipio, index) => {
                            return (
                              <MenuItem
                                key={municipio.codigo_municipio}
                                value={municipio.codigo_municipio}
                              >
                                {municipio.nome_municipio}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      )}
                    />
                  </Grid>
                ) : null}

                {visible ? (
                  <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                    <Controller
                      name="uf_endereco"
                      control={control}
                      defaultValue={notaFiscal.uf_endereco}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          error={error}
                          disabled={visible}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          placeholder="UF"
                        />
                      )}
                    />
                  </Grid>
                ) : null}

                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="cep_endereco"
                    control={control}
                    mask="99999-999"
                    defaultValue={notaFiscal.cep_endereco}
                    render={({
                      field: { onChange, onBlur, ref, value },
                      fieldState: { error },
                    }) => (
                      <InputMask
                        mask="99999-999"
                        disabled={true}
                        maskChar={'_'}
                        value={value}
                        onBlur={onBlur}
                        onChange={onChange}
                      >
                        {(inputProps) => (
                          <TextField
                            margin="normal"
                            error={error}
                            disabled={true}
                            helperText={error && error.message}
                            fullWidth
                            {...inputProps}
                            id="cep_endereco"
                            placeholder="CEP"
                          />
                        )}
                      </InputMask>
                    )}
                  />
                </Grid>
              </Grid>
              <Grid style={{ margin: 5 }} container spacing={1}>
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                  <strong>Contato</strong>
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="telefone_contato"
                    control={control}
                    rules={{ required: 'Telefone é obrigatório' }}
                    mask={mask}
                    defaultValue={notaFiscal.telefone_contato}
                    render={({
                      field: { onChange, ref, value },
                      fieldState: { error },
                    }) => (
                      <InputMask
                        mask={mask}
                        maskChar={'_'}
                        onBlur={(e) => {
                          const v = e.target.value.replace(/\D/g, '');
                          if (v.length === 10) {
                            setMask('(99) 9999-9999');
                          } else {
                            setMask('(99) 99999-9999');
                          }
                        }}
                        onFocus={(e) => {
                          setMask('(99) 99999-9999');
                        }}
                        onChange={onChange}
                        value={value}
                      >
                        {(inputProps) => (
                          <TextField
                            margin="normal"
                            error={error}
                            helperText={error && error.message}
                            fullWidth
                            {...inputProps}
                            id="telefone"
                            placeholder="Telefone"
                          />
                        )}
                      </InputMask>
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                  <Controller
                    name="email_contato"
                    control={control}
                    defaultValue={notaFiscal.email_contato}
                    rules={{
                      required: 'Email é obrigatório',
                      pattern: {
                        value:
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: 'Insira um e-mail válido',
                      },
                    }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <TextField
                        margin="normal"
                        value={value}
                        error={error}
                        helperText={error && error.message}
                        onChange={onChange}
                        fullWidth
                        placeholder="E-mail"
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid style={{ margin: 5 }} container spacing={1}>
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                  <strong>Valor</strong>
                </Grid>
                <Grid
                  marginTop={2}
                  item
                  xs={12}
                  sm={4}
                  style={{ paddingTop: 0 }}
                >
                  <Controller
                    name="valor_servico"
                    control={control}
                    defaultValue={notaFiscal.valor_servico}
                    rules={{ required: 'Valor é obrigatório' }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <CurrencyTextField
                        id={'valor_servico'}
                        placeholder="Valor Serviço"
                        variant="outlined"
                        value={value}
                        disabled={visible && radioValue !== 'pdf'}
                        error={error}
                        fullWidth
                        helperText={error && error.message}
                        decimalCharacter=","
                        digitGroupSeparator="."
                        currencySymbol="R$"
                        onChange={(event, value) => onChange(value)}
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid style={{ margin: 5 }} container spacing={1}>
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                  <strong>Discriminação</strong>
                </Grid>
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                  <Controller
                    name="discriminacao_servico"
                    control={control}
                    defaultValue={notaFiscal.discriminacao_servico}
                    rules={{ required: 'Discriminação é obrigatório' }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <TextField
                        margin="normal"
                        disabled={visible && radioValue !== 'pdf'}
                        value={value}
                        id="discriminacao"
                        error={error}
                        helperText={error && error.message}
                        onChange={onChange}
                        multiline
                        rows={4}
                        fullWidth
                        placeholder="Discriminação Serviço"
                      />
                    )}
                  />
                </Grid>
              </Grid>
              {usersComunicacao.includes(gestor) ? (
                <Grid style={{ margin: 5 }} container spacing={1}>
                  <Grid item xs={12} style={{ paddingTop: 0 }}>
                    <strong>Possui nota fiscal de subcontratada?</strong>
                  </Grid>
                  <Grid container item xs={12} justifyContent={'space-between'}>
                    <Controller
                      name="subcontratada"
                      control={control}
                      defaultValue="yes"
                      render={({ name, onBlur, onChange, value }) => (
                        <RadioGroup
                          row
                          value={radioValueSub}
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          onChange={(e) => {
                            changeTipoSub(e.target.value);
                          }}
                        >
                          <FormControlLabel
                            checked={radioValueSub === 'yes'}
                            value="yes"
                            control={<Radio />}
                            label="Sim"
                          />
                          <FormControlLabel
                            checked={radioValueSub === 'no'}
                            value="no"
                            control={<Radio />}
                            label="Não"
                          />
                        </RadioGroup>
                      )}
                    />
                  </Grid>
                  {radioValueSub == 'yes' ? (
                    <Grid
                      container
                      sm={4}
                      item
                      justifyContent={'space-between'}
                    >
                      <Box
                        style={{
                          width: '100%',
                          marginBottom: 10,
                          marginTop: '10px',
                        }}
                      >
                        <Autocomplete
                          defaultValue={null}
                          noOptionsText="Nenhuma opção encontrada"
                          loadingText="Carregando..."
                          getOptionLabel={(option) =>
                            `${option.nome_fornec} - ${option.cnpj_fornec}`
                          }
                          options={options}
                          id="controlled-demo"
                          fullWidth
                          value={fornecedor}
                          loading={loadingAutocomplete}
                          filterOptions={filterOptions}
                          onChange={(event, newValue) => {
                            setFornecedor(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              onChange={onChangeAutoComplete}
                              {...params}
                              placeholder="Fornecedor Nome ou CNPJ"
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {loadingAutocomplete ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Box>
                    </Grid>
                  ) : null}
                  {radioValueSub == 'yes' ? (
                    <Grid
                      item
                      sm={4}
                      style={{ paddingTop: 0, marginBottom: 10 }}
                    >
                      <Controller
                        name="numero_nf_subcontratada"
                        control={control}
                        defaultValue={notaFiscal.numero_nf_subcontratada}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            margin="normal"
                            placeholder="Número NF"
                            value={value}
                            type="number"
                            id="numero_nf_subcontratada"
                            InputProps={{
                              inputProps: {
                                min: 0,
                              },
                            }}
                            error={error}
                            helperText={error && error.message}
                            onChange={onChange}
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                  ) : null}
                  {radioValueSub == 'yes' ? (
                    <Grid
                      item
                      sm={4}
                      style={{ paddingTop: 0, marginBottom: 10 }}
                    >
                      <Controller
                        name="plano_basico"
                        control={control}
                        defaultValue={notaFiscal.plano_basico}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <TextField
                            margin="normal"
                            placeholder="Plano Básico"
                            value={value}
                            type="number"
                            id="plano_basico"
                            InputProps={{
                              inputProps: {
                                min: 0,
                              },
                            }}
                            error={error}
                            helperText={error && error.message}
                            onChange={onChange}
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                  ) : null}
                </Grid>
              ) : null}
              {visible && radioValue == 'xml' ? (
                <Grid style={{ margin: 5 }} container spacing={1}>
                  <Grid item xs={12} style={{ paddingTop: 0 }}>
                    <strong>Identificação Rps</strong>
                  </Grid>
                  <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                    <Controller
                      name="numero_identificacao_rps"
                      control={control}
                      defaultValue={notaFiscal.numero_identificacao_rps}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          disabled={visible}
                          value={value}
                          error={error}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          placeholder="Número Rps"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                    <Controller
                      name="serie_rps"
                      control={control}
                      defaultValue={notaFiscal.serie_rps}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          error={error}
                          disabled={visible}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          label="Série"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} style={{ paddingTop: 0 }}>
                    <Controller
                      name="tipo_rps"
                      control={control}
                      defaultValue={notaFiscal.tipo_rps}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          disabled={visible}
                          error={error}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          label="Tipo"
                        />
                      )}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={4}>
                    <Controller
                      name="natureza_operacao"
                      control={control}
                      defaultValue={notaFiscal.natureza_operacao}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          error={error}
                          disabled={visible}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          label="Natureza Operação"
                        />
                      )}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={4}>
                    <Controller
                      name="regime_especial_tributacao"
                      control={control}
                      defaultValue={notaFiscal.regime_especial_tributacao}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          error={error}
                          disabled={visible}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          label="Regime Especial Tributação"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Controller
                      name="optante_simples_nacional"
                      control={control}
                      defaultValue={notaFiscal.optante_simples_nacional}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          error={error}
                          disabled={visible}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          label="Optante Simples Nacional"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Controller
                      name="incentivador_cultural"
                      control={control}
                      defaultValue={notaFiscal.incentivador_cultural}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          disabled={visible}
                          error={error}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          label="Incentivador Cultural"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Controller
                      name="codigo_item_lista_servico"
                      control={control}
                      defaultValue={notaFiscal.codigo_item_lista_servico}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          error={error}
                          disabled={visible}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          label="Item Lista de Serviços"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Controller
                      name="codigo_tributacao_municipio"
                      control={control}
                      defaultValue={notaFiscal.codigo_tributacao_municipio}
                      render={({
                        field: { onChange, value },
                        fieldState: { error },
                      }) => (
                        <TextField
                          margin="normal"
                          value={value}
                          error={error}
                          disabled={visible}
                          helperText={error && error.message}
                          onChange={onChange}
                          fullWidth
                          label="Código Tributação Município"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </Grid>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              pt: 2,
              justifyContent: 'space-between',
              gap: 1,
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="warning"
              style={{ marginRight: '0.5rem' }}
              disabled={!dataEmissaoValida}
              onClick={() => {
                setIsRascunho(true);
              }}
            >
              Salvar como rascunho
              <SaveIcon />
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={loading || !dataEmissaoValida}
              onClick={() => {
                setIsRascunho(false);
              }}
            >
              Próximo
              <ArrowRightAltIcon />
            </Button>
          </Box>
        </form>
      </CardContent>
    </Card>
  );
};
